import script from "./itemV3Stones.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3Stones.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3Stones.vue?vue&type=style&index=0&id=7c1a87df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1a87df"]])

export default __exports__